import React, { Component } from "react";
import { connect } from "react-redux";
// import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
// import style from "./ReportIncome.module.css";
import moment from "moment";
import { fetchCustomersTreatmentIncome } from "../../../redux";
import { Field, Form, Formik } from "formik";
// import { DatePicker } from "antd";
// import * as Yup from "yup";
// import {
//   TabContent,
//   TabPane,
//   Nav,
//   NavItem,
//   NavLink,
//   Card,
//   Button,
//   CardTitle,
//   CardText,
//   Row,
//   Col,
// } from "reactstrap";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
// import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Select } from "antd";

const { Option } = Select;


function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

const model = {
    age_range: "",
    gender: "",
    icd_code: "",
    medical_aid: "",
  };

export class CustomersTreatmentIncome extends Component {
  constructor(props) {
    super(props);
    this.state = {
        ...model,
      page: 1,
      sortName: "",
      sortOrder: "",
      sortBy: "",
      customer_based_on: "age_range",
      isDataFetched: false,
      customersTreatmentIncome:[],
    };
    this.setLoader = this.setLoader.bind(this);
  }
  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
      <div>
        {/* <Link>
          <i class="fa fa-pencil-square-o mr-3 relatedpartylist-edit-icon"></i>
        </Link>
        <a class="action-icons relatedpartylist-add-icon">
          <i class="fa fa-trash"></i>
        </a> */}
      </div>
    );
  }

  componentDidMount = async() => {
    
    const payload = this.getPayload();
    await this.props.fetchCustomersTreatmentIncome(
        this.state.sortBy, 
        this.state.page,
        payload);

    if(this.props.customersTreatmentIncomeData && 
      this.props.customersTreatmentIncomeData.customersTreatmentIncome &&
      this.props.customersTreatmentIncomeData.customersTreatmentIncome.customers){
        this.setState({
            customersTreatmentIncome: this.props.customersTreatmentIncomeData.customersTreatmentIncome.customers
        })
    }
    setTimeout(() => {
      if (this.props.customersTreatmentIncomeData.customersTreatmentIncome.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);

    
      //Updating parent state for export filters
      let parentPayload = {
        sortBy: this.state.sortBy,
        ...payload
    }
    this.props.updateParentState(parentPayload);
  }


    /**
   * This will return payload object.
   */
  getPayload = () => {
    return {
    age_range: this.state.age_range,
    gender: this.state.gender,
    icd_code: this.state.icd_code,
    medical_aid: this.state.medical_aid,
    };
  };


  callCustomersTreatmentIncomeAPI = async() => {
    this.setState({
      customersTreatmentIncome: []
    })
    
    const payload = this.getPayload();
    await this.props.fetchCustomersTreatmentIncome(this.state.sortBy, this.state.page, payload);

      if(!this.props.customersTreatmentIncomeData.loading){
          if(this.props.customersTreatmentIncomeData && 
            this.props.customersTreatmentIncomeData.customersTreatmentIncome && 
            this.props.customersTreatmentIncomeData.customersTreatmentIncome.customers){
                this.setState({
                    customersTreatmentIncome:  this.props.customersTreatmentIncomeData.customersTreatmentIncome.customers
                })
          }
        setTimeout(() => {
            this.setState({
              isDataFetched: true,
            });
        }, 500);
      }
      //Updating parent state for export filters
      let parentPayload = {
        sortBy: this.state.sortBy,
        ...payload
    }
    this.props.updateParentState(parentPayload);

  }
  
  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callCustomersTreatmentIncomeAPI();
    });
    
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ 
      page,
      isDataFetched: false 
    },()=>{
      this.callCustomersTreatmentIncomeAPI();
    });
  };


  handleInputChange = (event) => {
    let filterval = event.target.value;

    this.setState({
      [event.target.name]: filterval,
      page: 1,
      isDataFetched: false
    },()=>{
      this.callCustomersTreatmentIncomeAPI();
    })
  }
  
  handleCustomerBasedOnChange = (event) => {
    let filterval = event.target.value;

    this.setState({
      customer_based_on: filterval,
      age_range: "",
      gender:""
    })
  }

  /**
   * This method will be called when tab is changed.
   */
  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        page: 1,
        sortName: undefined,
        sortOrder: undefined,
        sortBy: "",
        isDataFetched: false,
        ...model
      }, () => {
        this.callCustomersTreatmentIncomeAPI();
      });
    }
  };


  /**
   * This method will be called when there is not data or data is being fetched to show the loader.
   */
  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt='loader' className="loader-image" />
        </div>
      );
    }
  }

  /**
  * This method will be called to format the table data for valid data.
  * @param {string} data of the table column.
  * @returns {string} data or Not available string
  */
  checkValidData = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data;
    }
  }

  /**
  * This method will be called to format the table data for valid data.
  * @param {string} data of the table column.
  * @returns {string} data with first letter capital or Not available string
  */
  detailFormatter = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return  data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
    }
  }

  /**
   * This method will clear all the filters which are selected.
   */
  handleClearFilters = () => {
    this.setState({
      ...model,
      page: 1,
      sortName: "",
      sortOrder: "",
      sortBy: "",
      customer_based_on: "age_range",
      isDataFetched: false
    }, () => {
      console.log("state", this.state)
      this.callCustomersTreatmentIncomeAPI();
    })
  }


    /**
   * This will return filter form HTML for the render method.
   */
  getCustomerTreatmentFilter = () => {
    
    return (
        <Formik>
          <div className={`row form-group `}>
                <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <label>Choose customer based on:</label>
                  <Field
                    name="customer_based_on"
                    as="select"
                    placeholder="Select"
                    className="form-control"
                    value={this.state.customer_based_on}
                    onChange={this.handleCustomerBasedOnChange}
                  >
                    <option value="age_range">Age</option>
                    <option value="gender">Gender</option>
                  </Field>
                </div>
               {this.state.customer_based_on === "age_range" && ( <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <label>Age Group</label>
                  <Field
                    name="age_range"
                    as="select"
                    placeholder="Based on"
                    className="form-control"
                    value={this.state.age_range}
                    onChange={this.handleInputChange}
                  >
                    <option value="">Select</option>
                    <option value="1">Less than 10 years</option>
                    <option value="2">Less than 50 years</option>
                    <option value="3">50 years or Above</option>
                  </Field>
                </div>)}
                { this.state.customer_based_on === "gender" &&(
                    <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                    <label>Gender</label>
                    <Field
                        name="gender"
                        as="select"
                        placeholder="gender"
                        className="form-control"
                        value={this.state.gender}
                        onChange={this.handleInputChange}
                    >
                        <option value="">Select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </Field>
                    </div>
                )}
                <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <label>Medical Aid/Funder</label>
                  <Field
                    name="medical_aid"
                    as="select"
                    placeholder="Medical aid"
                    className="form-control"
                    value={this.state.medical_aid}
                    onChange={this.handleInputChange}
                  >
                    <option value="">All</option>
                  </Field>
                </div>

            <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label>ICD 10 Code</label>
              <Field
                    name="icd_code"
                    as="select"
                    placeholder="ICD Code"
                    className="form-control"
                    value={this.state.icd_code}
                    onChange={this.handleInputChange}
                  >
                    <option value="">Select ICD Code</option>
                  </Field>
            </div>
          </div>
          </Formik>
    );
  };

  render() {
    const customersTreatmentIncomeData = this.props.customersTreatmentIncomeData && this.props.customersTreatmentIncomeData.customersTreatmentIncome;
    //console.log("customersTreatmentIncome", customersTreatmentIncomeData);

    return (
        <div className="inventory-tab-wrapper flex-wrap">
        <div className="row">
        <div className="col-md-6">
           <p>Filter the customers based on the following:</p>
          </div>
          <div className="col-md-6 d-flex justify-content-md-end">
            <a className="clearFilters"
              href="javascriptVoid:0"
              onClick={this.handleClearFilters}>
              Clear Filters
              </a>
          </div>
          <div className="col-md-12">
            {this.getCustomerTreatmentFilter()}
          </div>
         
        </div>

        <div className="row">
          <div className={`col-md-12`}>
            <BootstrapTable
            remote={true}
            data={this.state.customersTreatmentIncome}
            version="4"
            bordered={false}
            search={false}
            pagination
            fetchInfo={{
              dataTotalSize: customersTreatmentIncomeData &&  customersTreatmentIncomeData.total ? customersTreatmentIncomeData.total:0,
            }}
            options={{
              searchvalue: "",
              sortName: this.state.sortName,
              sortOrder: this.state.sortOrder,
              onSortChange: this.onSortChange,
              // onSearchChange: this.onSearchChange,
              sizePerPage: 10,
              page: this.state.page,
              onPageChange: this.onPageChange,
              noDataText: this.setLoader(),
            }}>
              <TableHeaderColumn
                dataField="name"
                dataSort={true}
                dataFormat={this.checkValidData}
              >
                Name
                </TableHeaderColumn>
              <TableHeaderColumn
                dataField="related_party_id"
                isKey={true}
                dataFormat={this.checkValidData}
                dataSort={true}
              >
                Customer Id
               </TableHeaderColumn>
              <TableHeaderColumn
                dataField="age"
                dataSort={true}
                dataFormat={this.checkValidData}
              >
                Age
               </TableHeaderColumn>
              <TableHeaderColumn
                dataField="gender"
                dataSort={true}
                dataFormat={this.checkValidData}
              >
                Gender
               </TableHeaderColumn>
              <TableHeaderColumn
                dataField="last_appointment_date"
                dataSort={true}
                dataFormat={dateFormatter}
              >
                Last Appointment
               </TableHeaderColumn>
              <TableHeaderColumn
                dataField="payment_mode"
                dataSort={true}
                dataFormat={this.checkValidData}
              >
                Payment Options
               </TableHeaderColumn>
              {/* <TableHeaderColumn
                dataField="amount"
                dataSort={true}
                dataFormat={this.actionsFormatter}
              >
                Actions
               </TableHeaderColumn> */}
            </BootstrapTable>
          </div>
        </div>
      </div>
    );
  }
}

// export default Users;
const mapStateToProps = (state) => {
  return {
    customersTreatmentIncomeData: state.customersTreatmentIncome,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCustomersTreatmentIncome: (sortBy, page, payload) => dispatch(fetchCustomersTreatmentIncome(sortBy, page, payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomersTreatmentIncome);
